import { ControlModes } from '@src/types/Stacks';
import cloneDeep from 'lodash.clonedeep';
import { FormValues } from '../types';

export const generateDefaultFormValues = (
  controlMode: ControlModes,
): FormValues => {
  const defaultValues: FormValues = {};

  controlMode.sections.forEach((section) => {
    if (section.fields) {
      section.fields.forEach((field) => {
        const fieldName = field.controllerField;
        defaultValues[fieldName] = field.value;
      });
    }
  });

  return defaultValues;
};

export const mapFormValuesToControlMode = (
  formValues: FormValues,
  controlMode: ControlModes,
): ControlModes => {
  const updatedControlMode = cloneDeep(controlMode);

  updatedControlMode.sections.forEach((section) => {
    if (section.fields) {
      section.fields.forEach((field) => {
        const fieldName = field.controllerField;
        if (fieldName in formValues) {
          field.value =
            field.type === 'boolean'
              ? formValues[fieldName] === 1
              : formValues[fieldName];
        }
      });
    }
  });

  return updatedControlMode;
};
